import { Icon, Modal, Text } from '@pukka/ui-components';
import { Button } from 'flowbite-react';

interface TnCModalProps {
  readonly open?: boolean;
  readonly onToggleModal?: (open: boolean) => void;
}

function TnCModal({ open, onToggleModal }: TnCModalProps) {
  return (
    <Modal unwrap open={open} onOpenChange={onToggleModal}>
      <Modal.Content className="bg-neutral-50">
        <Modal.Title className="flex-row justify-between">
          Syarat dan Ketentuan Recurring Payment
          <Modal.Trigger asChild>
            <Button variant="nude" size="none" className="rounded-md">
              <Icon icon="close" color="white" />
            </Button>
          </Modal.Trigger>
        </Modal.Title>
        <Modal.Body className="my-0 max-h-128 p-6">
          <Text>
            <ol className="list-decimal pb-4 pl-6">
              <li className="pb-1">
                Mitra Usaha mengakui dan setuju bahwa MOKA dapat bekerjasama dengan pihak ketiga untuk menyediakan layanan recurring
                payment;
              </li>
              <li className="pb-1">
                Mitra Usaha setuju bahwa MOKA dapat memberikan Informasi Pribadi mengenai Mitra Usaha, termasuk namun tidak terbatas pada
                informasi alat pembayaran yang dipilih Mitra Usaha untuk digunakan di fitur recurring payment, ke pihak ketiga penyedia
                layanan penunjang recurring payment untuk tujuan pemrosesan transaksi recurring payment dengan tunduk pada ketentuan
                Kebijakan Privasi MOKA;
              </li>
              <li className="pb-1">
                Opsi alat pembayaran yang dapat digunakan dalam fitur recurring payment akan diberitahukan oleh MOKA dari waktu ke waktu;
              </li>
              <li className="pb-1">
                Mitra Usaha wajib memastikan terdapat saldo dan/atau sisa kredit yang cukup untuk pelaksanaan recurring payment. Dalam hal
                tidak terdapat saldo dan/atau sisa kredit yang cukup, MOKA berhak menghentikan layanan yang digunakan oleh Mitra Usaha,
                termasuk namun tidak terbatas pada layanan MokaPOS;
              </li>
              <li className="pb-1">
                Setiap pembayaran yang telah dilakukan tidak dapat dimintakan pengembalian (refund), kecuali atas kebijakan MOKA;
              </li>
              <li className="pb-1">
                Apabila terdapat chargeback, maka permintaan chargeback hanya dapat diajukan kepada bank terkait apabila ada dispute, dan
                hanya bisa dilakukan maksimal 5 hari kerja setelah tanggal transaksi, Apabila pengajuan diatas 5 hari kerja setelah
                transaksi, maka tidak dapat diproses.{' '}
              </li>
              <li className="pb-1">
                Terkait dengan pengajuan permintaan chargeback oleh Mitra Usaha kepada bank, Mitra Usaha mengakui dan menyetujui bahwa MOKA
                berhak untuk bekerjasama dengan bank dan/atau pihak ketiga penyedia layanan penunjang recurring payment, termasuk namun
                tidak terbatas pada memberikan informasi Mitra Usaha yang dibutuhkan, untuk kepentingan penyelesaian permintaan chargeback
                Mitra Usaha.
              </li>
              <li className="pb-1">
                Mitra Usaha akan mendapatkan pemberitahuan pengajuan chargeback disetujui ataupun ditolak secara langsung dari bank.
              </li>
              <li className="pb-1">
                Untuk proses verifikasi alat pembayaran yang Mitra Usaha pilih untuk digunakan di fitur recurring payment, MOKA akan
                mengenakan sejumlah biaya sebagai bentuk verifikasi yang mana biaya tersebut akan otomatis dikembalikan (refund) melalui
                sistem.
              </li>
            </ol>
            Syarat dan Ketentuan Recurring Payment ini tunduk pada (i) Ketentuan Penggunaan Layanan MokaPOS, (iii) Kebijakan Privasi MOKA,
            (iii) syarat dan ketentuan lainnya yang relevan yang diterbitkan oleh MOKA dan (iv) ketentuan perundang-undangan yang berlaku.
          </Text>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}

export { TnCModal };
